import { Action, configureStore, ThunkAction } from "@reduxjs/toolkit";
import { reducer as auth } from "@onmo/auth";
import gamePlay from "./slices/gamePlay";
import appState from "./slices/appState";

export const store = configureStore({
  reducer: {
    auth,
    gamePlay,
    appState,
  },
});

// Infer the `RootState` and `AppDispatch` types from the store itself
export type RootState = ReturnType<typeof store.getState>;
// Inferred type: {posts: PostsState, comments: CommentsState, users: UsersState}
export type AppDispatch = typeof store.dispatch;
export type AppThunk<ReturnType = void> = ThunkAction<
  ReturnType,
  RootState,
  unknown,
  Action<string>
>;

export type AsyncAppThunk<ReturnType = Promise<void>> = ThunkAction<
  ReturnType,
  RootState,
  unknown,
  Action<string>
>;
